import { Record } from 'immutable';

export default class StaffingCompanyGroupUsageRecord extends Record({
  id: undefined,
  bankId: undefined,
  fileStorage: undefined,
  ratsit: undefined,
  sms: undefined,
}) {
}
